if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        console.log('ProductForm: onSubmitHandler called');
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          console.log('ProductForm: Button already loading, returning');
          return;
        }

        // Validate required product addons before proceeding
        console.log('ProductForm: About to validate addons');
        if (!this.validateRequiredAddons()) {
          console.log('ProductForm: Validation failed, preventing submission');
          return;
        }
        console.log('ProductForm: Validation passed, proceeding with submission');

        // Add addon properties to the form before submission
        this.addAddonPropertiesToForm();

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart.updateSectionContents();
              return;
            }

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      addAddonPropertiesToForm() {
        // Check if product addons exist
        if (!window.productAddons) return;
        
        const properties = window.productAddons.getCartProperties();
        
        // Remove any existing addon property inputs to avoid duplicates
        const existingInputs = this.form.querySelectorAll('input[name^="properties["]');
        existingInputs.forEach(input => {
          if (input.name.includes('Add-on') || input.name.includes('Option')) {
            input.remove();
          }
        });
        
        // Add new hidden inputs for each addon property
        Object.keys(properties).forEach(key => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = properties[key];
          this.form.appendChild(input);
        });
        
        if (Object.keys(properties).length > 0) {
          console.log('Cart properties added:', properties);
        }
      }

      validateRequiredAddons() {
        console.log('=== Addon Validation Started ===');
        
        // Addon dropdowns are not inside the form - they're separate blocks on the page
        // Search in the entire document (or at least the product section)
        const requiredDropdowns = document.querySelectorAll('[data-addon-select][required]');
        console.log('Found required dropdowns:', requiredDropdowns.length);
        
        // Debug: log all addon dropdowns
        const allDropdowns = document.querySelectorAll('[data-addon-select]');
        console.log('Found total addon dropdowns:', allDropdowns.length);
        allDropdowns.forEach((dropdown, i) => {
          console.log(`Dropdown ${i + 1}:`, {
            hasRequired: dropdown.hasAttribute('required'),
            value: dropdown.value,
            selectedIndex: dropdown.selectedIndex
          });
        });
        
        if (requiredDropdowns.length === 0) {
          console.log('No required addons found - validation passes');
          return true; // No required addons, validation passes
        }
        
        const unselectedAddons = [];
        
        requiredDropdowns.forEach((dropdown, index) => {
          const selectedValue = dropdown.value;
          const selectedOption = dropdown.options[dropdown.selectedIndex];
          const optionType = selectedOption?.dataset?.type;
          
          console.log(`Checking required dropdown ${index + 1}:`, {
            value: selectedValue,
            optionType: optionType,
            selectedIndex: dropdown.selectedIndex
          });
          
          // Check if nothing is selected or if the "empty" option is selected
          if (!selectedValue || optionType === 'empty') {
            const addonBlock = dropdown.closest('[data-addon-block]');
            const addonLabel = addonBlock?.dataset?.addonLabel || 'addon';
            console.log(`Dropdown ${index + 1} is not selected:`, addonLabel);
            unselectedAddons.push(addonLabel);
          }
        });
        
        if (unselectedAddons.length > 0) {
          console.log('Validation FAILED - Unselected addons:', unselectedAddons);
          
          // Build error message
          let message;
          if (unselectedAddons.length === 1) {
            message = `Please select an option for "${unselectedAddons[0]}" before adding to cart.`;
          } else {
            message = `Please select options for the following required fields: ${unselectedAddons.join(', ')}`;
          }
          
          this.showAddonNotification(message);
          
          // Highlight the first unselected dropdown
          const firstUnselectedDropdown = Array.from(requiredDropdowns).find(dropdown => {
            const selectedOption = dropdown.options[dropdown.selectedIndex];
            const optionType = selectedOption?.dataset?.type;
            return !dropdown.value || optionType === 'empty';
          });
          
          if (firstUnselectedDropdown) {
            firstUnselectedDropdown.focus();
            firstUnselectedDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          
          console.log('Add to cart prevented: Required addon not selected');
          console.log('=== Addon Validation Failed ===');
          return false;
        }
        
        console.log('Validation PASSED - All required addons selected');
        console.log('=== Addon Validation Completed ===');
        return true;
      }

      showAddonNotification(message) {
        // Remove any existing notifications
        const existingNotification = document.querySelector('.addon-notification');
        if (existingNotification) {
          existingNotification.remove();
        }
        
        // Create notification element
        const notification = document.createElement('div');
        notification.className = 'addon-notification addon-notification--error';
        notification.innerHTML = `
          <div class="addon-notification__content">
            <svg class="addon-notification__icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor"/>
            </svg>
            <span class="addon-notification__message">${message}</span>
          </div>
        `;
        
        // Add styles if not already present
        if (!document.querySelector('#addon-notification-styles')) {
          const style = document.createElement('style');
          style.id = 'addon-notification-styles';
          style.textContent = `
            .addon-notification {
              position: fixed;
              top: 20px;
              left: 50%;
              transform: translateX(-50%) translateY(-100px);
              background: white;
              padding: 16px 24px;
              border-radius: 8px;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              z-index: 10000;
              max-width: 500px;
              animation: slideDown 0.3s ease-out forwards;
            }
            
            .addon-notification--error {
              border-left: 4px solid #dc2626;
            }
            
            .addon-notification__content {
              display: flex;
              align-items: center;
              gap: 12px;
            }
            
            .addon-notification__icon {
              flex-shrink: 0;
              color: #dc2626;
            }
            
            .addon-notification__message {
              color: #1f2937;
              font-size: 14px;
              line-height: 1.5;
              font-weight: 500;
            }
            
            @keyframes slideDown {
              to {
                transform: translateX(-50%) translateY(0);
              }
            }
            
            @keyframes slideUp {
              from {
                transform: translateX(-50%) translateY(0);
              }
              to {
                transform: translateX(-50%) translateY(-100px);
              }
            }
            
            .addon-notification--hiding {
              animation: slideUp 0.3s ease-out forwards;
            }
            
            @media (max-width: 640px) {
              .addon-notification {
                top: 10px;
                left: 10px;
                right: 10px;
                transform: translateY(-100px);
                max-width: none;
              }
              
              @keyframes slideDown {
                to {
                  transform: translateY(0);
                }
              }
              
              @keyframes slideUp {
                from {
                  transform: translateY(0);
                }
                to {
                  transform: translateY(-100px);
                }
              }
            }
          `;
          document.head.appendChild(style);
        }
        
        // Add to page
        document.body.appendChild(notification);
        
        // Auto-dismiss after 4 seconds
        setTimeout(() => {
          notification.classList.add('addon-notification--hiding');
          setTimeout(() => {
            notification.remove();
          }, 300);
        }, 4000);
      }
    },
  );
}
